import React from "react";
import {useTranslation} from "react-i18next";

import MDButton from "materialDashboard/components/MDButton";
import MDBox from "materialDashboard/components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import MDLoadingButton from "../../components/MDLoadingButton";
import useDialog from "../../components/useDialog";
import {useUsersExportMutation} from "./query";


const ExportDialog = ({isOpen, close, userFilter={}}) => {
    const {t} = useTranslation(["users"]);
    const userExportMutation = useUsersExportMutation();

    const handleExport = async () => {
        await userExportMutation.mutateAsync({...userFilter, format: "CSV"});
        close();
    }

    const isLoading = userExportMutation.isLoading;

    return <Dialog onClose={close} open={isOpen} maxWidth="lg" fullWidth>
        <DialogTitle>{t('export.title')}</DialogTitle>
        <DialogContent>
            {t('export.description')}
        </DialogContent>
        <DialogActions>
            <MDButton onClick={close} color="info" variant="outlined">
                {t('export.cancel')}
            </MDButton>
            <MDLoadingButton onClick={handleExport}
                             color="info"
                             variant="gradient"
                             loading={isLoading}>
                {t('export.buttonLabel')}
            </MDLoadingButton>
        </DialogActions>
    </Dialog>

}


const ExportToolbar = ({userFilter}) => {
    const {t} = useTranslation(["users"]);
    const dialogState = useDialog();
    return <MDBox py={2} px={3}>
        <MDLoadingButton variant="outlined"
                         color="info"
                         onClick={dialogState.open}
                         sx={{alignSelf: "flex-start"}}>
            {t('export.buttonLabel')}
        </MDLoadingButton>
        <ExportDialog isOpen={dialogState.isOpen}
                      close={dialogState.close}
                      userFilter={userFilter}/>
    </MDBox>

}

export default ExportToolbar;